import { NgModule} from '@angular/core';
import { MdTabsModule, MdInputModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DownloadComponent } from './dashboard.component';
import { FileUploadModule } from '../fileUpload.module';
import { TranslateModule } from 'ng2-translate';

@NgModule({
    imports: [
        MdTabsModule,
        MdInputModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FileUploadModule,
        TranslateModule
    ],
    declarations: [
        DownloadComponent
    ],
    exports: [
        
    ]
})

export class DashboardModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/dashboard/dashboard.module.ts